import { Button as WCButton } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

const Button = styled(WCButton)`
  margin: 0 auto;
  min-width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export default Button
